import { withStyles } from '@material-ui/core';

import { ErrorTooltip as LocalErrorTooltip } from './ErrorTooltip';
import { errorTooltipStyles } from './errorTooltipStyles';

export const ErrorTooltip = withStyles(errorTooltipStyles)(LocalErrorTooltip);
